import { reduce } from "et3-type-guards";
import configuration from "../../configuration/keys/index";

export const firebaseConfig = {
  apiKey: reduce(() => configuration.apiKey, ""),
  authDomain: reduce(() => configuration.authDomain, ""),
  projectId: reduce(() => configuration.projectId, ""),
  storageBucket: reduce(() => configuration.storageBucket, ""),
  messagingSenderId: reduce(() => configuration.messagingSenderId, ""),
  appId: reduce(() => configuration.appId, "")
};

export const firebaseVapidKey = reduce(
  () => configuration.firebaseVapidKey,
  ""
);
